
































declare var window: any;
import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { RecruiterRequest } from '../models/referrals/recruiterrequest';
import { RecruiterResponse } from '../models/referrals/recruiterresponse';
import { ReferFriendRequest } from '../models/referrals/referfriendreqest';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import { Phone } from '../models/userdata/phone';
import { Recruiter } from '../models/referrals/recruiter';
import FormCard from './ReferAFriend/FormCard.vue';
import FormSection from './ReferAFriend/FormSection.vue';
import SectionContainer from './Commons/SectionContainer.vue';
import SectionTitle from './Commons/SectionTitle.vue';
import SubmitButton from './ReferAFriend/SubmitButton.vue';
import UserForm from './ReferAFriend/UserForm.vue';
import { ModelListSelect } from 'vue-search-select';
import UserFormValidator from './ReferAFriend/userFormValidator';
import MailClientOpener from '@/components/ReferAFriend/mailClientOpener';
import RecruiterListUtility from './ReferAFriend/recruiterListUtility';
import { mixins } from 'vue-class-component';

@Component({
  name: 'ReferAFriend',
  components: {
    FormCard,
    SectionTitle,
    SectionContainer,
    SubmitButton,
    UserForm,
    ModelListSelect,
    FormSection,
  },
})
export default class ReferAFriend extends mixins(
  UserFormValidator,
  MailClientOpener,
  RecruiterListUtility,
) {
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private recruiter: Recruiter = new Recruiter();
  private referFriendRequest: ReferFriendRequest = new ReferFriendRequest();
  private errorString: string = '';
  private friendInfo: CommonUserInfo = new CommonUserInfo();
  private successString: string = '';
  private searchText: string = '';
  $wlToastr: any;

  get getReferFriendTitle() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED')
      ? this.$t('referafriendexternal.title')
      : this.$t('referafriend.title');
  }

  get canShowReferralBonusMessage() {
    return !vxm.configs.getGlobalConfigBooelanValue('DISABLE_REFERRAL_BONUS_INFO_IN_REFERRAL_PAGE')
  }

  get supportedFileSize() {
    return vxm.utility.fileUploadMaxSize;
  }
  sendReferFriendRequest() {
    let validationMessage;
    validationMessage = this.formValidator(this.friendInfo);
    if (validationMessage) {
      return this.$wlToastr(
        'error',
        validationMessage,
        this.$t('referafriend.title'),
      );
    }
    if(this.friendInfo.mobile==null && this.friendInfo.phoneNumber.length>0){
      this.friendInfo.phoneNumber = ''
    }

    if (
      this.friendInfo.email === vxm.users.myUserProfile.email ||
      this.friendInfo.phoneNumber === vxm.users.myUserProfile.phoneNum
    ) {
      this.$wlToastr('error', this.$t('quicksignup-details-same-referrer'), '');
      return;
    }
    if (
      this.friendInfo.lastName.length < 2 ||
      this.validateLastName(this.friendInfo.lastName)
    ) {
      this.$wlToastr(
        'error',
        this.$t('referafriend.lastname.validation.error'),
        '',
      );
      return;
    }
    if (this.friendInfo.resumeFile && this.friendInfo.resumeFile.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', {maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return;
    }
    this.referFriendRequest.friendList.push(this.friendInfo);
    this.referFriendRequest.commonUserInfo.userId =
      vxm.users.myUserProfile.userId;
    this.referFriendRequest.commonUserInfo.firstName =
      vxm.users.myUserProfile.firstName;
    this.referFriendRequest.commonUserInfo.lastName =
      vxm.users.myUserProfile.lastName;
    this.referFriendRequest.commonUserInfo.email =
      vxm.users.myUserProfile.email;
    this.referFriendRequest.commonUserInfo.phoneNumber =
      vxm.users.myUserProfile.phoneNum + '';

    this.referFriendRequest.commonUserInfo.recruiterName = this.recruiter.recruiterName;
    this.referFriendRequest.commonUserInfo.recruiterEmail = this.recruiter.recruiterEmail;
    this.referFriendRequest.companyCode =
      vxm.jobs.BrandingInfo.companycode || '';

    const friendDetail = JSON.stringify({
      email: this.friendInfo.email,
      firstName: this.friendInfo.firstName,
      lastName: this.friendInfo.lastName,
      phoneNumber: this.friendInfo.phoneNumber,
      additionalNote: this.friendInfo.additionalNote
    })
    const payload = new FormData()
    payload.append('companyCode', vxm.jobs.BrandingInfo.companycode)
    payload.append('friendDetail', friendDetail)
    payload.append('recruiterEmail', this.recruiter.recruiterEmail)
    payload.append('sourceChannelValue','Talent Portal');

    this.friendInfo.resumeFile && payload.append('friendsResume', this.friendInfo.resumeFile)
    if (vxm.utmtracker.utmTrackerId > 0) {
      payload.append('utmTrackerId', String(vxm.utmtracker.utmTrackerId));
    }

    vxm.referrals.referTheFriend(payload).then(() => {
      if (vxm.referrals.EmployeeReferralResponse.errorCode) {
        this.$wlToastr(
          'error',
          vxm.referrals.EmployeeReferralResponse.errorMessage,
          this.$t('ResumeDetails_UploadResume'),
        );
      } else {
        vxm.users.Rudderstack.trackEvent("Friend Referral", {
          referralType: "Refer a friend",
          recruiterId : this.recruiter.recruiterId
    })
        this.$wlToastr(
          'success',
          this.canShowReferralBonusMessage
            ? vxm.referrals.EmployeeReferralResponse.successMessage
            : this.$t('referafriend.form.submit.success.message.without.bonus'),
          '',
        );
        
        this.mailClientOpener(this.friendInfo.email);
        
        this.friendInfo = new CommonUserInfo();
        this.referFriendRequest = new ReferFriendRequest();
        this.recruiter = new Recruiter();
        this.recruiterResponse = new RecruiterResponse();
      }
    });
    // new referral PG ends
  }
  get isAutomateEmails(){
  return vxm.configs.getGlobalConfigValue('WL_AUTOMATE_REFERRAL_EMAILS');
}
  printSearchText(searchText: string, initCall = false) {
    this.recruiterRequest.searchString = searchText;
    this.recruiterRequest.company = vxm.jobs.BrandingInfo.companycode;
    if (
      (searchText.trim().length >= 3 && !this.autoPopulateRecruiterList) ||
      (initCall && this.autoPopulateRecruiterList)
    ) {
      this.recruiterRequest.pageNumber = initCall ? -1 : 1;
      this.recruiterRequest.pageSize = initCall ? 50 : 5;
      const respPromise: any = vxm.referrals
        .getRecruiterListByCompany(this.recruiterRequest)
        .then((values) => {
          if (vxm.referrals.RecruiterResponse.recruiterList !== null) {
            this.recruiterResponse = vxm.referrals.RecruiterResponse;
          }
        });
    }
  }

  validateLastName(lastname: string) {
    const specialChars = /[0-9`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(lastname);
  }

  mounted() {
    if (this.autoPopulateRecruiterList) {
      this.printSearchText('', true);
    }
  }
}
